import { isEmpty } from '@client/common/utils/empty/empty';
import { WishlistDetailedType } from 'b2b-common/core/account/api/wishlists';

const isAddItemsToCartDisabled = (
  data: WishlistDetailedType | null,
  selectedItems: string[],
): boolean => {
  if (!data || isEmpty(data.items)) {
    return false;
  }

  if (selectedItems.length > 0) {
    return (
      data.items.filter(
        (item) => selectedItems.includes(item.sku) && item.isActive,
      ).length === 0
    );
  }

  if (selectedItems.length === 0) {
    return data.items.filter((item) => item.isActive).length === 0;
  }

  return false;
};

export {
  isAddItemsToCartDisabled,
};
